export const PENDING_FRIEND_REQUEST = 'PENDING_FRIEND_REQUEST';
